export default __webpack_public_path__ + "static/media/4bet24.9b5ec212.svg";